module.exports = __webpack_public_path__ + "img/_DSC7772.c4e16df5.jpg";